import { LuLogOut } from "react-icons/lu";
import { useAuth } from '../../../context/AuthContext'
import MegaButton from '../../styled-components/Buttons/MegaButton/MegaButton'

export function LogOutButton({...props}) {
  const { logout, isLoggingOut } = useAuth()

  async function cerrarSession(){
    console.log(' --- cerrarSession()')
    try {
      await logout()
    } catch (error) {
      console.error('Error al cerrar sesión:', error)
    }
  }

  return (
    <MegaButton
      loading={isLoggingOut}
      labelText={<LuLogOut size={24}/>}
      className={'text-white !p-2 transition-all duration-300 bg-red-500/30 hover:bg-red-600'} 
      onClick={()=> cerrarSession()}
    />
  )
}